module.exports = __webpack_public_path__ + "e616ec2953c1ac22142f6b3084a799fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/cover/schneefeld_mobile.jpg
// module id = 137
// module chunks = 0